import type { MisconceptionDefinition } from '../types'

export const GET_VERHOUDINGEN: MisconceptionDefinition[] = [
  {
    id: 'get.verh-verdelen-door-verkeerd-aantal-delen',
    label: 'Deelt door verkeerd aantal delen',
    module: 'Getalbegrip',
    description:
      'Leerling deelt door het aantal delen van één groep (bv. ÷3 bij 2:3) i.p.v. door het totaal (2+3=5).',
    typicalFamilies: ['GET-VERH-VERDELEN'],
  },
  {
    id: 'get.verh-verdelen-halveert',
    label: 'Halveert in plaats van verhouding',
    module: 'Getalbegrip',
    description:
      'Leerling halveert het totaal i.p.v. de verhouding te gebruiken (denkt: gelijke verdeling).',
    typicalFamilies: ['GET-VERH-VERDELEN'],
  },
  {
    id: 'get.verh-verdelen-grootste-kleinste-verwisseld',
    label: 'Grootste en kleinste deel verwisseld',
    module: 'Getalbegrip',
    description:
      'Leerling geeft het kleinste deel als antwoord op de vraag naar het grootste deel (of andersom).',
    typicalFamilies: ['GET-VERH-VERDELEN'],
  },
  {
    id: 'get.verh-verdelen-totaal-keer-deel',
    label: 'Totaal vermenigvuldigd met deel',
    module: 'Getalbegrip',
    description:
      'Leerling vermenigvuldigt het totaal met het aantal delen i.p.v. eerst 1 deel te berekenen.',
    typicalFamilies: ['GET-VERH-VERDELEN'],
  },
  {
    id: 'get.verh-verdelen-deelt-door-een-deel',
    label: 'Deelt door één verhoudingsgetal',
    module: 'Getalbegrip',
    description:
      'Leerling deelt door één van de verhoudingsgetallen (bv. ÷2 of ÷3) i.p.v. door de som.',
    typicalFamilies: ['GET-VERH-VERDELEN'],
  },
  {
    id: 'get.verh-recept-vermenigvuldigt-totaal',
    label: 'Vermenigvuldigt totaal i.p.v. per stuk',
    module: 'Getalbegrip',
    description:
      'Leerling vermenigvuldigt de oorspronkelijke hoeveelheid met het nieuwe aantal i.p.v. eerst per stuk te berekenen.',
    typicalFamilies: ['GET-VERH-RECEPT'],
  },
  {
    id: 'get.verh-recept-verdubbelt',
    label: 'Verdubbelt altijd',
    module: 'Getalbegrip',
    description:
      'Leerling verdubbelt de hoeveelheid ongeacht de factor (denkt: meer = ×2).',
    typicalFamilies: ['GET-VERH-RECEPT'],
  },
  {
    id: 'get.verh-recept-factor-fout',
    label: 'Verkeerde factor gebruikt',
    module: 'Getalbegrip',
    description:
      'Leerling gebruikt een verkeerde factor (bv. ÷ i.p.v. ×, of telt op i.p.v. vermenigvuldigt).',
    typicalFamilies: ['GET-VERH-RECEPT'],
  },
  {
    id: 'get.verh-recept-per-stuk-onjuist',
    label: 'Berekening per stuk onjuist',
    module: 'Getalbegrip',
    description:
      'Leerling berekent een onjuiste hoeveelheid per persoon/stuk (rekenfout in de deling).',
    typicalFamilies: ['GET-VERH-RECEPT'],
  },
  {
    id: 'get.verh-recept-verhouding-als-gelijk',
    label: 'Verhouding als gelijk gezien',
    module: 'Getalbegrip',
    description:
      'Leerling gebruikt evenveel van beide ingrediënten i.p.v. de verhouding (bv. 3:1).',
    typicalFamilies: ['GET-VERH-RECEPT'],
  },
  {
    id: 'get.schaal-vermenigvuldigt-met-100',
    label: 'Vermenigvuldigt cm op kaart met verkeerde factor',
    module: 'Getalbegrip',
    description:
      'Leerling past de schaalfactor verkeerd toe (bv. × 100 i.p.v. × 100000) of vergeet de eenheid om te zetten.',
    typicalFamilies: ['GET-VERH-SCHAAL-KAART', 'GET-VERH-SCHAAL'],
  },
  {
    id: 'get.schaal-eenheid-fout',
    label: 'Eenheid vergeten of verkeerd omgezet',
    module: 'Getalbegrip',
    description:
      'Leerling zet de eenheden niet om (cm blijft cm) of past een verkeerde omzetting toe (bv. cm → m i.p.v. cm → km).',
    typicalFamilies: ['GET-VERH-SCHAAL-KAART', 'GET-VERH-SCHAAL'],
  },
  {
    id: 'get.schaal-deelt-omgekeerd',
    label: 'Deelt door schaalfactor in verkeerde richting',
    module: 'Getalbegrip',
    description:
      'Leerling deelt door de schaalfactor i.p.v. te vermenigvuldigen om de werkelijke afstand te vinden (of omgekeerd).',
    typicalFamilies: ['GET-VERH-SCHAAL-KAART', 'GET-VERH-SCHAAL'],
  },
]
